export default "__VITE_ASSET__BiIW9QL$__"